import { makeStyles } from '@branchjs/neo-components';

export const useStyles = makeStyles((theme) => ({
  formInputAndButtonAndFooterContainer: {
    margin: '48px 0 0 0',
    width: '475px',
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  formInput: {
    marginBottom: '48px',
  },
  button: {
    marginBottom: '48px',
  },
  footer: {
    ...theme.typography.body2,
    color: theme.colors.text[900],
    alignSelf: 'center',
  },
}));
